import { useLang } from "@/lib/i18n";
import { whatsappUrl } from "@/lib/translations";

export const CtaBanner = () => {
  const { lang, t } = useLang();
  return (
    <section
      data-testid="cta-banner"
      className="py-20 md:py-32 bg-[#fafafa] border-t border-neutral-200"
    >
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-16 text-center">
        <div className="overline mb-8">— {t.contact.overline} —</div>
        <h2 className="editorial-h text-5xl md:text-7xl lg:text-8xl mx-auto max-w-4xl">
          {t.hero.titleC}{" "}
          <span className="italic text-neutral-500">{t.hero.titleD.replace(",", "")}</span>
        </h2>
        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4">
          <a
            data-testid="cta-banner-whatsapp"
            href={whatsappUrl(lang)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-black text-white hover:bg-neutral-800 transition-colors text-[12px] tracking-[0.15em] uppercase"
          >
            {t.hero.ctaPrimary}
          </a>
          <a
            data-testid="cta-banner-secondary"
            href="#contact"
            className="inline-flex items-center justify-center gap-3 px-8 py-4 border border-black hover:bg-black hover:text-white transition-colors text-[12px] tracking-[0.15em] uppercase"
          >
            {t.nav.contact}
          </a>
        </div>
      </div>
    </section>
  );
};
